import { PoiAccessibilityEnum, PoiPriority, PoiStatus } from '@/__generated__/graphql';
import { GeneralFieldConfig } from './types';

export const BULK_EDIT_MANDATORY_KEYS = ['poiId', 'name', 'assembly'] as const;

export const GENERAL_FIELD_CONFIGS: GeneralFieldConfig[] = [
  {
    key: 'poiId',
    label: 'POI ID',
    fieldType: 'TEXT',
    isBulkEditable: false,
    isMandatory: true,
  },
  {
    key: 'name',
    label: 'POI Name',
    fieldType: 'TEXT',
    isBulkEditable: true,
    isMandatory: true,
  },
  {
    key: 'assembly',
    label: 'Component',
    fieldType: 'TEXT',
    isBulkEditable: false,
    isMandatory: true,
  },
  {
    key: 'status',
    label: 'Status',
    fieldType: 'SELECT',
    isBulkEditable: true,
    options: [
      { value: PoiStatus.Inprogress, label: 'In Progress' },
      { value: PoiStatus.Completed, label: 'Completed' },
      { value: PoiStatus.Inreview, label: 'In Review' },
      { value: PoiStatus.ChaseItemAdded, label: 'Chase Item Added' },
      { value: PoiStatus.PartiallyCompleted, label: 'Partially Completed' },
      { value: PoiStatus.Remediated, label: 'Remediated' },
    ],
  },
  {
    key: 'priority',
    label: 'Priority',
    fieldType: 'SELECT',
    isBulkEditable: true,
    options: [
      { value: PoiPriority.Low, label: 'Low' },
      { value: PoiPriority.Medium, label: 'Medium' },
      { value: PoiPriority.High, label: 'High' },
    ],
  },
  {
    key: 'accessibility',
    label: 'Accessibility',
    fieldType: 'SELECT',
    isBulkEditable: true,
    options: [
      { value: PoiAccessibilityEnum.ScaffoldingRequired, label: 'Scaffolding Required' },
      { value: PoiAccessibilityEnum.NoScaffoldingRequired, label: 'No Scaffolding Required' },
      { value: PoiAccessibilityEnum.NotApplicable, label: 'Not Applicable' },
    ],
  },
  {
    key: 'assignee',
    label: 'Assignee',
    fieldType: 'TEXT',
    isBulkEditable: false,
  },
  {
    key: 'comment',
    label: 'Comment',
    fieldType: 'TEXT',
    isBulkEditable: false,
  },
  {
    key: 'dueDate',
    label: 'Due Date',
    fieldType: 'DATE',
    isBulkEditable: true,
  },
];

export const DEFAULT_VISIBLE_GENERAL_KEYS = ['poiId', 'name', 'assembly', 'status', 'priority'];
